<h2 mat-dialog-title>
  {{ "commonSaveConfirmDialog.title" | translate }}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <div *ngIf="!customMessage" class="container" fxLayout="column" fxLayoutAlign="center center">
    <p>{{ message | translate }}</p>
    <p *ngIf="isMove" [innerHTML]="isMovingMessage | translate"></p>
    <p *ngIf="!isMove" [innerHTML]="isClosingMessage | translate"></p>
  </div>
  <div *ngIf="customMessage" class="container" fxLayout="column">
    <p class="first-message">{{ message | translate }}</p>
    <p class="seccond-message" [innerHTML]="customMessage | translate"></p>
  </div>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions fxFlex fxLayout="row" fxLayoutAlign="center center">
    <!-- Combined action buttons into one div -->
    <div class="action-buttons">
      <button class="do-not-save-button" mat-button color="primary" [mat-dialog-close]="false">{{ notSaveBtnLabel | translate }}</button>
      <button class="cancel-button" mat-button color="primary" mat-dialog-close>{{ cancelBtnLabel | translate }}</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial *ngIf="!isError">{{ saveBtnLabel | translate }}</button>
    </div>
  </mat-dialog-actions>
</div>
